export default {
  accessToken(state) {
    return state.accessToken;
  },
  account(state) {
    return state.account;
  },
  isAuthenticated(state) {
    return state.account != null;
  },
}